import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import NavBar from "./components/NavBar";
import HomePage from "./pages/HomePage";
import Lesson from "./pages/Lesson";
import NewsLesson from "./pages/NewsLesson";
import ScrollToTopFunction from "./components/ScrollToTopFunction";

import { ZeroOneKLessons } from "./modules/ZeroOneKLessons";
import { OneTwoKLessons } from "./modules/OneTwoKLessons";
import { TwoThreeKLessons } from "./modules/TwoThreeKLessons";
import { ThreeFourKLessons } from "./modules/ThreeFourKLessons";
import { FourFiveKLessons } from "./modules/FourFiveKLessons";
import { FiveSixKLessons } from "./modules/FiveSixKLessons";
import { News1 } from "./modules/News1";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTopFunction></ScrollToTopFunction>
      <NavBar></NavBar>

      <Routes>
        <Route path="/" element={<HomePage />} />
        {ZeroOneKLessons.map((item) => (
          <Route
            key={item.lessonNumber}
            path={`/01klesson${item.lessonNumber}`}
            element={
              <Lesson
                lesson={item}
                lessonBand="0-1000"
                lessonCode="01"
                mainArray={ZeroOneKLessons}
              />
            }
          />
        ))}
        {OneTwoKLessons.map((item) => (
          <Route
            key={item.lessonNumber}
            path={`/12klesson${item.lessonNumber}`}
            element={
              <Lesson
                lesson={item}
                lessonBand="1000-2000"
                lessonCode="12"
                mainArray={OneTwoKLessons}
              />
            }
          />
        ))}
        {TwoThreeKLessons.map((item) => (
          <Route
            key={item.lessonNumber}
            path={`/23klesson${item.lessonNumber}`}
            element={
              <Lesson
                lesson={item}
                lessonBand="2000-3000"
                lessonCode="23"
                mainArray={TwoThreeKLessons}
              />
            }
          />
        ))}
        {ThreeFourKLessons.map((item) => (
          <Route
            key={item.lessonNumber}
            path={`/34klesson${item.lessonNumber}`}
            element={
              <Lesson
                lesson={item}
                lessonBand="3000-4000"
                lessonCode="34"
                mainArray={ThreeFourKLessons}
              />
            }
          />
        ))}
        {FourFiveKLessons.map((item) => (
          <Route
            key={item.lessonNumber}
            path={`/45klesson${item.lessonNumber}`}
            element={
              <Lesson
                lesson={item}
                lessonBand="4000-5000"
                lessonCode="45"
                mainArray={FourFiveKLessons}
              />
            }
          />
        ))}
        {FiveSixKLessons.map((item) => (
          <Route
            key={item.lessonNumber}
            path={`/56klesson${item.lessonNumber}`}
            element={
              <Lesson
                lesson={item}
                lessonBand="5000-6000"
                lessonCode="56"
                mainArray={FiveSixKLessons}
              />
            }
          />
        ))}
        {News1.map((item) => (
          <Route
            key={item.lessonNumber}
            path={`/NewsVocabulary${item.lessonNumber}`}
            element={
              <NewsLesson
                lesson={item}
                lessonBand=""
                lessonCode=""
                mainArray={News1}
              />
            }
          />
        ))}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
